(function () {
  const features = [
    // {
    //   key: 'feature-key',
    //   type: 'feature',
    // },
    // {
    //   key: 'experiment-key',
    //   type: 'experiment',
    //   pages: ['/products/experiment-product', '/collections/experiment-collection'],
    // },
    {
      key: 'monogramming-button',
      type: 'feature',
      pages: ['/products/garment-duffel', '/products/garment-duffel-premium'],
    },
  ];

  const loadVisibilityClasses = function () {
    const styleElement = document.createElement("style");
    document.head.appendChild(styleElement);

    const sheet = styleElement.sheet;

    features.forEach(function (feature) {
      var groups = undefined;
      var prefix = undefined;

      if (feature.type == 'experiment') {
        groups = ['control', 'variation'];
        prefix = '.e';
      } else {
        groups = ['disabled', 'enabled'];
        prefix = '.ft';
      }

      const featureClass = `${prefix}-${feature.key}`;

      groups.forEach(function (classGroup) {
        sheet.insertRule(`${featureClass}-${classGroup}-visible { display: none !important; }`, sheet.cssRules.length);
        sheet.insertRule(`${featureClass}-${classGroup}-visible-inline-block { display: none !important; }`, sheet.cssRules.length);

        sheet.insertRule(`${featureClass}--${classGroup} ${featureClass}-${classGroup}-visible { display: block !important; }`, sheet.cssRules.length);
        sheet.insertRule(`${featureClass}--${classGroup} ${featureClass}-${classGroup}-visible-inline-block { display: inline-block !important; }`, sheet.cssRules.length);
        sheet.insertRule(`${featureClass}--${classGroup} ${featureClass}-${classGroup}-hidden { display: none !important; }`, sheet.cssRules.length);
      });
    });
  }

  loadVisibilityClasses();

  const whenExperimentsLoaded = function () {
    return new Promise(function (resolve) {
      if (window._growthbook && window._growthbook.ready) {
        window._growthbook.updateAttributes({ deviceType: getDeviceType(), url: window.location.href })
        resolve(window._growthbook);
      } else {
        setTimeout(function () {
          resolve(whenExperimentsLoaded());
        }, 100);
      }
    });
  }

  whenExperimentsLoaded().then(function (gb) {
    features.forEach(function (feature) {
      var classGroup = undefined;
      var classPrefix = undefined;

      if (feature.type == 'experiment') {
        classGroup = gb.isOn(feature.key) ? 'variation' : 'control';
        classPrefix = 'e';
      } else {
        classGroup = gb.isOn(feature.key) ? 'enabled' : 'disabled';
        classPrefix = 'ft';
      }

      if (feature.type == 'feature' || !feature.pages.length || feature.pages.includes(window.location.pathname)) {
        document.querySelector('body').classList.add(`${classPrefix}-${feature.key}--${classGroup}`);
      }
    });
  });

  window.Experiments = window.Experiments || [];
  window.Experiments.whenLoaded = whenExperimentsLoaded;
  window.Experiments.whenLoaded().then(function () {
    document.body.style.visibility = 'visible';
  });

  //setTimeout(function () {
  //  if (document.body.style.visibility != 'visible') {
  //    console.warn('GrowthBook failed to load.');
  //    document.body.style.visibility = "visible";
  //  }
  //}, 3000);

  // How to wait for experiments anywhere.
  // window.Experiments.whenLoaded().then(function (gb) {
  //   if (gb.getFeatureValue(<FEATURE_NAME>, <DEFAULT_VALUE>)) {
  //     do stuff...
  //   }
  // }
})();
